var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.setBackPack,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-hover table-sm" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("ID")]),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th", [_vm._v("Имя")]),
            _vm._v(" "),
            _vm.useBackPacks ? _c("th", [_vm._v("Рюкзак")]) : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.runners, function (runner, index) {
            return Number(index)
              ? _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(index))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selected_runner,
                          expression: "selected_runner",
                        },
                      ],
                      attrs: {
                        name: "runner_radio",
                        type: "radio",
                        id: "r_" + index,
                      },
                      domProps: {
                        value: index,
                        checked: _vm._q(_vm.selected_runner, index),
                      },
                      on: {
                        change: function ($event) {
                          _vm.selected_runner = index
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "label",
                      { staticClass: "pointer", attrs: { for: "r_" + index } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(runner) + "\n          "
                        ),
                        _vm.runnerOrders &&
                        _vm.runnerOrders[index] &&
                        _vm.runnerOrders[index].length
                          ? _c("span", [
                              _vm._v(
                                "\n                      (" +
                                  _vm._s(_vm.runnerOrders[index].length) +
                                  ")\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.runnerOrders &&
                    _vm.runnerOrders[index] &&
                    _vm.runnerOrders[index].length
                      ? _c("i", {
                          staticClass: "icon-fa icon-fa-hand-o-down",
                          on: {
                            click: function ($event) {
                              return _vm.goTo(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.useBackPacks
                    ? _c("td", { staticClass: "text-right" }, [
                        _vm.backPacks && _vm.backPacks[index]
                          ? _c("div", { staticClass: "backpack" }, [
                              _c("span", { staticClass: "w_backpack" }, [
                                _vm._v("с рюкзаком"),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.backPacks &&
                        !_vm.backPacks[index] &&
                        _vm.runnerOrders &&
                        _vm.runnerOrders[index] &&
                        _vm.runnerOrders[index].length
                          ? _c("div", { staticClass: "backpack" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success btn-xs",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalBackPack(index)
                                    },
                                  },
                                },
                                [_vm._v("выдать")]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              : _vm._e()
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }